import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PendingActions = ({ actions = [], onActionClick }) => {
  const priorityConfig = {
    high: {
      label: 'Alta',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20',
      icon: 'AlertCircle'
    },
    medium: {
      label: 'Media',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      icon: 'AlertTriangle'
    },
    low: {
      label: 'Baja',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20',
      icon: 'Info'
    }
  };

  if (actions?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-6 md:p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-success/10 mb-4">
          <Icon name="CheckCircle2" size={32} className="text-success" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
          Sin Acciones Pendientes
        </h3>
        <p className="text-sm md:text-base caption text-muted-foreground">
          Todas las tareas están completadas
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-2 overflow-hidden">
      <div className="bg-gradient-to-r from-warning/10 to-error/10 p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-warning/20">
            <Icon name="AlertCircle" size={24} className="text-warning" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              Acciones Pendientes
            </h2>
            <p className="text-sm caption text-muted-foreground">
              {actions?.length} {actions?.length === 1 ? 'tarea requiere' : 'tareas requieren'} atención
            </p>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6 space-y-3 md:space-y-4">
        {actions?.map((action, index) => {
          const priority = priorityConfig?.[action?.priority] || priorityConfig?.medium;
          
          return (
            <div
              key={index}
              className={`
                p-4 md:p-5 rounded-lg border ${priority?.borderColor}
                ${priority?.bgColor} transition-smooth hover-lift
              `}
            >
              <div className="flex items-start gap-3 md:gap-4 mb-3">
                <div className={`p-2 rounded-lg ${priority?.bgColor} flex-shrink-0`}>
                  <Icon name={priority?.icon} size={20} className={priority?.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
                      {action?.title}
                    </h3>
                    <span className={`px-2 py-0.5 rounded text-xs font-body font-medium ${priority?.color} ${priority?.bgColor}`}>
                      {priority?.label}
                    </span>
                  </div>
                  <p className="text-sm md:text-base font-body text-foreground mb-3">
                    {action?.description}
                  </p>
                  <div className="flex flex-wrap items-center gap-3 md:gap-4 text-xs md:text-sm caption text-muted-foreground">
                    {action?.assignedTo && (
                      <div className="flex items-center gap-1.5">
                        <Icon name="User" size={14} />
                        <span>{action?.assignedTo}</span>
                      </div>
                    )}
                    {action?.dueDate && (
                      <>
                        <span className="hidden md:inline">•</span>
                        <div className="flex items-center gap-1.5">
                          <Icon name="Calendar" size={14} />
                          <span>Vence: {action?.dueDate}</span>
                        </div>
                      </>
                    )}
                    {action?.isOverdue && (
                      <>
                        <span className="hidden md:inline">•</span>
                        <div className="flex items-center gap-1.5 text-error">
                          <Icon name="AlertCircle" size={14} />
                          <span className="font-medium">Vencida</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {action?.actionButton && (
                <div className="flex justify-end">
                  <Button
                    variant={action?.priority === 'high' ? 'destructive' : 'default'}
                    size="sm"
                    iconName={action?.actionIcon || 'ArrowRight'}
                    iconPosition="right"
                    onClick={() => onActionClick && onActionClick(action)}
                    className="mt-2"
                  >
                    {action?.actionButton}
                  </Button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PendingActions;